export default {
  data () {
    return {
      device : (window.innerWidth < 768) ? 'mobile' : ( (window.innerWidth > 1024) ? 'desktop' : 'tablet'),
    }
  }
};
